(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["size-guide-link"] && !Shopify.designMode) return;
  try {
    /**
   * Unit switch for the size guide drawer. The page content holds centimetres only;
   * inches are calculated here, so the page stays correct without JavaScript.
   * Also makes the horizontally scrolling tables keyboard reachable.
   */
  class SizeGuideUnits extends HTMLElement {
    static CM_PER_INCH = 2.54;
    static #instanceCount = 0;

    connectedCallback() {
      this.addEventListener('change', this.#onChange);

      // When the element is defined before the parser reaches its children, they are
      // not in the DOM yet; set up once the document is parsed.
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.#setup(), { once: true });
      } else {
        this.#setup();
      }
    }

    /** One-time setup; a reconnect (e.g. after a morph) keeps the existing state. */
    #setup() {
      if (this.numberFormat) return;
      const locale = document.documentElement.lang || 'de';
      this.numberFormat = new Intl.NumberFormat(locale, { minimumFractionDigits: 1, maximumFractionDigits: 1 });

      this.querySelectorAll('[data-unit-name]').forEach((element) => {
        const unit = element.getAttribute('data-unit-name');
        const name = new Intl.NumberFormat(locale, { style: 'unit', unit, unitDisplay: 'long' })
          .formatToParts(2)
          .find((part) => part.type === 'unit')?.value;
        if (name) element.textContent = ` (${name})`;
      });

      // Unique group name per instance: the quick add modal can hold a second copy of
      // the same product's size guide, and a shared name would link both switches.
      const groupName = `SizeGuideUnit-${++SizeGuideUnits.#instanceCount}`;
      this.querySelectorAll('input[type="radio"]').forEach((input) => {
        input.name = groupName;
      });

      this.querySelector('fieldset')?.removeAttribute('hidden');
      customElements.whenDefined('rte-formatter').then(() => this.#labelTableRegions());
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.#onChange);
    }

    /** @param {Event} event */
    #onChange = (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
      this.#showUnit(input.value);
    };

    /** @param {string} unit - 'cm' or 'in' */
    #showUnit(unit) {
      this.querySelectorAll('.size-guide-link__inner td').forEach((cell) => {
        if (cell.dataset.cm === undefined) cell.dataset.cm = cell.textContent.trim();
        const cm = Number.parseFloat(cell.dataset.cm.replace(',', '.'));
        if (Number.isNaN(cm)) return;
        cell.textContent = unit === 'in' ? this.numberFormat.format(cm / SizeGuideUnits.CM_PER_INCH) : cell.dataset.cm;
      });

      this.querySelectorAll('.size-guide-link__inner tbody th').forEach((header) => {
        header.textContent = header.textContent.replace(/\((cm|in)\)/, `(${unit})`);
      });
    }

    #labelTableRegions() {
      this.querySelectorAll('.size-guide-link__inner table').forEach((table) => {
        const wrapper = table.closest('.rte-table-wrapper');
        if (!wrapper) return;
        wrapper.setAttribute('tabindex', '0');
        wrapper.setAttribute('role', 'region');
        const caption = table.querySelector('caption')?.textContent.trim();
        if (caption) wrapper.setAttribute('aria-label', caption);
      });
    }
  }

  if (!customElements.get('size-guide-units')) {
    customElements.define('size-guide-units', SizeGuideUnits);
  }
  } catch(e) { console.error(e); }
})();

})();
